import { TokenDO, TokenData, TokenMetricNames, MetricColor } from "../models/tokenDO.models";
import { formatter } from "../../core/helpers/formatter";
import { i18n } from "../../internationalize/i18n.service";
import { tokenDataService } from "../services/tokenData.service";

import '../style/tokenData.css'

export class TokenDataContainer extends HTMLElement {
    constructor() {
        super()
        this.classList.add('token-data-container')
    }

    connectedCallback() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        this.load()
    }

    async load() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        const tokenData = await tokenDataService.getTokenData(tokenSlug)
        if (tokenData.length === 0) { throw new Error('No token data found') }

        this.setValues(this, this.getValues(tokenData[0]))
        this.style.display = 'flex'
    }

    setValues(container: HTMLElement, tokenDataItem: TokenData) {
        for (const metric in tokenDataItem) {
            const dataBox = document.createElement('div')
            if (tokenDataItem[metric] === null) { continue }

            const metricName = i18n.getLanguage() === 'fr' ? TokenMetricNames[metric].french : TokenMetricNames[metric].english
            dataBox.className = 'token-data-box'
            dataBox.innerHTML = `
                <div id='metric' class='caption1'>${metricName}</div>
                <div id='value' class='headline-5'">${tokenDataItem[metric]}</div>`

            if (metric === 'percent_change_24h') {
                const color = this.getColorFromValue(tokenDataItem, metric)
                const value: HTMLDivElement = dataBox.querySelector('#value')

                if (!value || !value.style) { continue }
                value.style.color = color
            }

            container.appendChild(dataBox)
        }
    }

    getValues(tokenDO: TokenDO): TokenData {
        const data = tokenDO.data
        const tokenDataItem = {
            price: formatter.formatPrice(data.price),
            percent_change_24h: formatter.formatPercentage(data.percent_change_24h),
            market_cap: formatter.formatLargeNumber(data.market_cap),
            fully_diluted_market_cap: formatter.formatLargeNumber(data.fully_diluted_market_cap),
            volume_24h: formatter.formatLargeNumber(data.volume_24h),
            market_cap_dominance: formatter.formatPercentage(data.market_cap_dominance),
        } as TokenData


        return tokenDataItem
    }

    private getColorFromValue(tokenDataItem: TokenData, metric: string) {
        // Color is neutral if the value is 0, positive if the value is greater than 0, and negative if the value is less than 0
        return parseFloat(tokenDataItem[metric]) === 0 ? MetricColor.neutral : parseFloat(tokenDataItem[metric]) > 0 ? MetricColor.positive : MetricColor.negative;
    }
}